import React from "react";
import { Link } from "react-router-dom";
import "./AboutUs.css"



const AboutUS = () => {
  return (
    
   
    <>
    <div className="container-xxl py-5 hero-header1">
      <div className="container my-5 py-5 px-lg-5">
        <div className="row g-5 py-5">
          <div className="col-12 text-center">
            <h1 className="text-white animated slideInDown">About-Us</h1>
            <hr className="bg-white mx-auto mt-0" style={{ width: "90px" }} />
          </div>
        </div>
      </div>
    </div>
    
      <section className="bg-white"  id="About-US">
      <div className="container pt-5 pb-5" >
        <div className="row">
        <div className="col-md-6 d-flex align-items-center">
        <div className="video-container ">
            <video autoPlay loop muted className="">
            <source src={`${process.env.PUBLIC_URL}/large3.mp4`} type="video/mp4" id="video1"/>
            </video>
        </div> 
        </div>

          <div className="col-md-6
          "  data-aos="fade-left">
            <h2 className="about-heading mt-5  text-black">About Us</h2>
            <p className="about-text text-secondary mb-5">
            We have some creative ideas for you. Your business is our top priority. We love our valued customers.
            Let us show you some stats We have done great stuff over the past few years. There are many variations of passages of Our work available, but the majority have suffered alteration in some form, by injected .
            
            <br/>
            <br/>
            Since 2017 we continuesly helping the companies and small buisness owners to promote their buisness and product worldwide. And also helping the people to build their social presence on all social media platforms. We spend the year's for developing our empire and now we become a international digital marketing company.
            </p>
            
            <Link to="/get-started#payment-section"
             className="get-started text-decoration-none py-sm-3 px-sm-5 rounded-pill me-3 animated slideInLeft"
             id="abtbtn"> Get Started</Link>

          </div>
        </div>
      </div>
      </section>

      <div className="container-xxl py-5 hero-header1" id="next">
      <div className="container my-5 py-5 px-lg-5">
        <div className="row g-5 py-5">
          <div className="col-12 text-center">
            
          <Link to="/get-started#payment-section"
             className="get-started text-decoration-none py-sm-3 px-sm-5 rounded-pill me-3 animated slideInLeft"
             id="abtbtn"> Get Started</Link>
          </div>
        </div>
      </div>
    </div>
      
    </>
  );
};

export default AboutUS;




